// extracted by css-extract-rspack-plugin
export default {"container":"Title-module__container__Rwmhs","header":"Title-module__header__ylm4U","expandButton":"Title-module__expandButton__y5D9c"};